import { render, staticRenderFns } from "./notice_privacy_club.vue?vue&type=template&id=48316137&scoped=true"
import script from "./notice_privacy_club.vue?vue&type=script&lang=js"
export * from "./notice_privacy_club.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48316137",
  null
  
)

export default component.exports